module.exports = __webpack_public_path__ + "img/label-white.70506b64.svg";